/*
 * Bubbles Entry Point
 * Loaded only when [bubbles_fx] shortcode is used.
 */

import * as THREE from 'three';
window.THREE = THREE;

import './home/bubbles.js';

function boot() {
  const canvas = document.getElementById('bubbles-canvas');
  if (!canvas || !window.BubblesFX) return;
  window.BubblesFX.create(canvas, {
    accent: canvas.dataset.accent || '#1745FF',
    count:  canvas.dataset.count  || 14,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
